import createSelector from 'web-app/util/custom-create-selector';
import * as SharedSelectors from 'web-app/react/plans/manage-plan/shared-selectors';

export const makeGetAvailableWeekdayProducts = () => {
    return createSelector(
        SharedSelectors.availableProducts,
        (state, props) => props.day,
        (availableProducts, day) => {
            return availableProducts.filter(product => product.availability.find(avDay => avDay === day));
        },
    );
};

export const makeGetAvailableWeekdaySessions = () => {
    return createSelector(
        SharedSelectors.availableSessions,
        (state, props) => props.day,
        (availableSessions, day) => {
            return availableSessions.filter(session => session.availability.find(av => av.day === day));
        },
    );
};

const getAvailabilityFromSessionId = (day, weekdaySessions, planUsedSessions, sessionId) => {
    const weekdaySession = weekdaySessions.find(session => session.sessionId === sessionId);
    if (weekdaySession) {
        return weekdaySession.availability.find(av => av.day === day);
    }

    const planUsedSession = planUsedSessions.find(session => session.sessionId === sessionId);

    if (planUsedSession) {
        return planUsedSession.availability.find(av => av.day === day);
    }
    return null;
};

export const makeGetAttending = () => {
    const getAvailableWeekdaySessions = makeGetAvailableWeekdaySessions();
    return createSelector(
        getAvailableWeekdaySessions,
        SharedSelectors.planUsedSessions,
        (_, props) => props.day,
        (_, props) => props.weekday.sessionBookings,
        (weekdaySessions, planUsedSessions, day, sessionBookings) => {
            const startEndTimes = sessionBookings
                .map(booking => {
                    if (booking.start && booking.end) {
                        return {
                            start: booking.start,
                            end: booking.end,
                        };
                    }

                    return getAvailabilityFromSessionId(day, weekdaySessions, planUsedSessions, booking.sessionId);
                })
                .filter(time => time);

            return startEndTimes.reduce(
                (reduction, current) => ({
                    start: reduction.start && reduction.start.isBefore(current.start) ? reduction.start : current.start,
                    end: reduction.end && reduction.end.isAfter(current.end) ? reduction.end : current.end,
                }),
                {
                    start: null,
                    end: null,
                },
            );
        },
    );
};
